<template>
    <main class="main" :class="pageClass">
        <ScheduleInfo v-if="hasSchedule" />
        <div class="container">
            <div class="content">
                <router-view :key="this.$route.fullPath" />

                <div id="preloader" :class="{active: showPreloader}">
                    <img src="@/assets/img/loader.svg" alt="" width="64" height="64" class="loader-spin">
                </div>
            </div>
        </div>
    </main>
</template>

<script>
  import ScheduleInfo from "@/components/shop/ScheduleInfo.vue";

  export default {
      name: 'ContentLayout',
      components: {ScheduleInfo},
      computed: {
          pageClass(){
              return ('page-' + this.$route.name).toLowerCase();
          },
          showPreloader(){
              return this.$store.getters.showPreloader
          },
          hasSchedule() {
            return Boolean(this.$route.params.scheduleId);
          },
      }
  }
</script>
